<template>
  <b-container class="discover-mobile">
    <b-row>
      <b-col>
        <b-row class="font-weight-normal mb-2">
          <p class="title">{{ $t('main.header.tags.discover') }}</p>
        </b-row>
        <b-row class="mb-5 d-flex flex-column">
          <div>
            <div
              class="menu-header pb-1 d-flex justify-content-between align-items-center"
              @click="contentsOpen = !contentsOpen"
            >
              <span class="submenu-title">{{ $t('discover.header.tags.content') }}</span>
              <span class="down-arrow">
                <Icon v-if="!contentsOpen" icon="bootstrap-chevron-down" :width="16" :height="16" />
                <Icon v-else icon="bootstrap-chevron-up" :width="16" :height="16" />
              </span>
            </div>
            <div class="contents content overflow-hidden" :class="{ open: contentsOpen }">
              <div v-for="(option, index) in discoverData" :key="index">
                <div v-if="option.typeLink == 'content'" class="link-submenu">
                  <Link
                    modal-name="discover-modal"
                    :internal-link="option.internalLink"
                    :translate-link="option.translateLink"
                    :value="option.value"
                    :link="option.link"
                    :link-subscriptor="option.linkSubscriptor"
                    :link-url-builder="option.linkUrlBuilder"
                  />
                </div>
              </div>
            </div>
            <hr class="m-0" />
          </div>
          <div>
            <div
              class="menu-header pb-1 d-flex justify-content-between align-items-center"
              @click="toolsOpen = !toolsOpen"
            >
              <span class="submenu-title">{{ $t('discover.header.tags.tools') }}</span>
              <span class="down-arrow">
                <Icon v-if="!toolsOpen" icon="bootstrap-chevron-down" :width="16" :height="16" />
                <Icon v-else icon="bootstrap-chevron-up" :width="16" :height="16" />
              </span>
            </div>
            <div class="contents tools overflow-hidden" :class="{ open: toolsOpen }">
              <div v-for="(option, index) in discoverData" :key="index">
                <div v-if="option.typeLink == 'tool'" class="link-submenu">
                  <Link
                    modal-name="discover-modal"
                    :internal-link="option.internalLink"
                    :translate-link="option.translateLink"
                    :value="option.value"
                    :link="option.link"
                    :link-subscriptor="option.linkSubscriptor"
                    :link-url-builder="option.linkUrlBuilder"
                  />
                </div>
              </div>
            </div>
            <hr class="m-0" />
          </div>
        </b-row>
        <b-row class="mb-3">
          <nuxt-link
            class="link"
            :to="$trailingSlash(localePath('our-graphics'))"
            @click.native="$bvModal.hide('discover-modal')"
            >{{ $t('discover.header.tags.latest') }}</nuxt-link
          >
        </b-row>
        <b-row class="mb-3">
          <nuxt-link
            class="link"
            :to="$trailingSlash(localePath('featured-vectors'))"
            @click.native="$bvModal.hide('discover-modal')"
            >{{ $t('discover.header.tags.featured') }}</nuxt-link
          >
        </b-row>
        <b-row class="mb-5">
          <nuxt-link
            class="link"
            :to="$trailingSlash(localePath('trending-vectors'))"
            @click.native="$bvModal.hide('discover-modal')"
            >{{ $t('discover.header.tags.trending') }}</nuxt-link
          >
        </b-row>
        <b-row class="mb-3">
          <a
            class="link"
            href="https://www.vexels.com/blog"
            rel="noopener noreferrer"
            target="_blank"
            >{{ $t('discover.header.tags.blog') }}</a
          >
        </b-row>
        <b-row>
          <Button
            shape="full"
            color="green text-uppercase"
            :to="$urlBuilder('plans', { keyword: 'discover' })"
            @click.native="$bvModal.hide('discover-modal')"
            >{{ $t('discover.header.tags.pricing') }}</Button
          >
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Icon from 'UI/Icon';
import Button from 'UI/Button';
import Link from './Link';
import discoverData from './discoverData.json';

export default {
  components: {
    Button,
    Icon,
    Link
  },
  data() {
    return {
      contentsOpen: false,
      toolsOpen: false,
      isShow: false,
      discoverData: discoverData
    };
  }
};
</script>

<style lang="scss">
@include xl {
  #discover-modal___BV_modal_header_ {
    border: none;
    position: absolute;
    right: -6px;
    top: -40px;
    @media screen and (max-height: 640px) {
      right: 0px;
      top: 0px;
    }
  }
  #discover-modal___BV_modal_content_ {
    border-radius: 9px;
    border: none;
  }
  #discover-modal___BV_modal_body_ {
    padding: 50px 38px;
  }

  #discover-modal {
    .title {
      font-size: 1.5em;
      font-weight: 500;
    }
    .link {
      color: black;
      font-size: 15px;
    }
    .menu-header {
      height: 55px;

      .submenu-title {
        font-size: 16px;
      }
    }
    .contents {
      transition: max-height 0.3s ease-out;
      max-height: 0;
      .link-submenu {
        padding: 5px 0;
        a {
          color: #202020;
          font-size: 13px;
        }
      }
    }
    .content.open {
      max-height: 400px;
      transition: max-height 0.3s ease-in;
    }
    .tools.open {
      max-height: 400px;
      transition: max-height 0.3s ease-in;
    }
  }
}
</style>
